const productionsLocalize = {
  "All manufactures are refused": "Todas as fichas foram rejeitadas",
  'card with some configuration error': 'Ficha com algum erro de configuração',
  'This manufacture has already been canceled': 'Esta ficha já foi cancelada'
};

export default productionsLocalize;


